export default __webpack_public_path__ + "static/banner-01cf638856c80214e85a2311186a16df.webp";